<template>
  <div class="app-container">
    <BjDivider right-fixed>{{ $t('goodsSku.detail.BasicInformation') }}
      <template slot="right">
        <template v-if="isAdd">
          <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button v-permission:BusinessGoodsSkuOrdinary_Audit type="primary" @click="handleConfirm(false)">{{ $t('saveText') }}</el-button>
        </template>
        <template v-if="isView">
          <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
        </template>
      </template>
    </BjDivider>

    <el-form ref="form" :model="goodsData" :rules="rules" label-width="230px" class="form" :disabled="!!type">
      <el-row>
        <el-col :span="colSpan">
          <el-form-item label="SKU" prop="skuCode">
            <BjInput v-model="goodsData.skuCode" type="textarea" show-word-limit autosize :disabled="!!goodsData.id" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuName')">
            <BjInput v-model="goodsData.skuName" type="textarea" show-word-limit autosize :maxlength="MAX_LENGTH.REMARK" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.ProductType')">
            <BjInput v-model="goodsData.itemType" type="textarea" show-word-limit autosize :maxlength="MAX_LENGTH.REMARK" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item v-if="goodsData.id" :label="$t('goodsSku.detail.ProductClassification')">{{ goodsData.categoryName }}</el-form-item>
          <el-form-item v-else :label="$t('goodsSku.detail.ProductClassification')">
            <BjGoodsTypeTreeSelect ref="BjGoodsTypeTreeSelect" v-model="goodsData.categoryId" @change="changeCategory" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item label="UOM Group">Manual</el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.UseSystemBarcode')">
            <el-switch v-model="goodsData.asignBarcode" :disabled="!!goodsData.id" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Barcode')">
            <span v-if="goodsData.asignBarcode">{{ goodsData.barCode }}</span>
            <BjInput v-else v-model="goodsData.barCode" :maxlength="MAX_LENGTH.REMARK" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Supplier')">
            <BjSelectSupplier v-model="goodsData.vendorId" :page-size="100" @change="changeSupplier" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.PurchasingDepartment')">
            <BjSelectLov v-model="goodsData.buyingDepId" :option-list="ROLE_LIST" :placeholder="$t('chooseText')" @change="changeRole" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Purchaser')">
<!--            <BjSelectLov v-model="goodsData.buyerName" :option-list="ROLE_USER_LIST" :placeholder="$t('chooseText')" @change="changeBuyer" />-->
            <BjInput v-model="goodsData.buyerName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Brand')">
            <BjSelectLov v-model="goodsData.brandId" :option-list="BRAND_LIST" :placeholder="$t('chooseText')" @change="changeBrand" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.packagingBarcode')">
            <BjInput v-model="goodsData.cartonBoxBarcode" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.SeasonalProducts')">All Seasonable</el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Merchandiser')">
            <BjInput v-model="goodsData.merchandiser" :maxlength="MAX_LENGTH.SMALLTEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Merchandiser2')">
            <BjInput v-model="goodsData.merchandiser2" :maxlength="MAX_LENGTH.SMALLTEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.ContinueSell')">
            <el-switch v-model="goodsData.discontinued" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.costPrice')">
            <BjInputMoney v-model="goodsData.costPrice" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.salesPrice')">
            <BjInputMoney v-model="goodsData.salesPrice" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.activityPrice')">
            <BjInputMoney v-model="goodsData.activityPrice" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.marketPrice')">
            <BjInputMoney v-model="goodsData.marketPrice" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.distributionPrice')">
            <BjInputMoney v-model="goodsData.distributionPrice" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.wholesalePrice')">
            <BjInputMoney v-model="goodsData.wholesalePrice" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.clearingPrice')">
            <BjInputMoney v-model="goodsData.clearingPrice" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item label="RMB">
            <BjInputMoney v-model="goodsData.rmb" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.Actual')">
            <BjInputMoney v-model="goodsData.actualProfitRate" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.Standard')">
            <BjInputMoney v-model="goodsData.standardProfitRate" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.rate')">
            <BjInputMoney v-model="goodsData.resendRefundRate" :maxlength="MAX_LENGTH.MINITEXT" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.Predicted')">
            <el-switch v-model="goodsData.isPrediction" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.InventoryProducts')">
            <el-switch v-model="goodsData.inventoryItem" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.PurchasedItems')">
            <el-switch v-model="goodsData.purchaseItem" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.SellingItems')">
            <el-switch v-model="goodsData.salesItem" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Fragile')">
            <el-switch v-model="goodsData.fragile" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.DangerousGoods')">
            <el-switch v-model="goodsData.dangerousGoods" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Flammable')">
            <el-switch v-model="goodsData.flammable" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <el-form-item label="预售">
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Picture')">
            <!-- <Upload ref="uploadRef" @handleFileChange="handleFileChange" @handleRemove="handleRemove" /> -->
            <BjUpload ref="BjUpload" class="avatar-uploader" auto-upload accept="image/png,image/jpeg" :accept-list="['image/jpeg', 'image/png']" :limit-size="100" @afterUpload="afterUpload">
              <template slot="default">
                <BjKeyImage v-if="goodsData.imageUrl" class="avatar" :url="goodsData.imageUrl" fit="cover" />
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </template>
            </BjUpload>
          </el-form-item>
        </el-col>

        <BjDivider>{{ $t('goodsSku.detail.CertificateList') }}
          <template>
            <el-button type="primary" @click="addSkuLicense">{{ $t('addText') }}</el-button>
          </template>
        </BjDivider>
        <el-table ref="storeTable" :data="goodsData.skuLicenseList" stripe border :header-cell-style="$rowStyle.DEFAULT">
          <el-table-column prop="licenseName" :label="$t('goodsSku.detail.CertificateName')">
            <template slot-scope="scope">
              <BjInput v-model="scope.row.licenseName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </template>
          </el-table-column>
          <el-table-column prop="licenseExpireDate " :label="$t('goodsSku.detail.CertificatePeriod')">
            <template slot-scope="scope">
              <BjDatePicker v-model="scope.row.licenseExpireDate" value-format="yyyy-MM-dd HH:mm:ss" />
            </template>
          </el-table-column>
          <el-table-column prop="licenseNode" :label="$t('goodsSku.detail.CertificateRemarks')">
            <template slot-scope="scope">
              <BjInput v-model="scope.row.licenseNode" :maxlength="MAX_LENGTH.REMARK" :placeholder="$t('inputText')" clearable />
            </template>
          </el-table-column>
          <el-table-column prop="action" :label="$t('operationText')" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="goodsData.skuLicenseList.splice(scope.$index,1)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <BjDivider style="margin-top:20px;">{{ $t('goodsSku.detail.AttributeTable') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.length')" prop="length">
            <BjInputMoney v-model="goodsData.length" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.width')" prop="width">
            <BjInputMoney v-model="goodsData.width" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.height')" prop="height">
            <BjInputMoney v-model="goodsData.height" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.weight')" prop="weight">
            <BjInputMoney v-model="goodsData.weight" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">kg</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.UnitVolume')">
            {{ (goodsData.width*goodsData.height*goodsData.length/1000000) }}m³
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.qty')" prop="qty">
            <BjInputMoney v-model="goodsData.qty" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonLength')" prop="cartonLength">
            <BjInputMoney v-model="goodsData.cartonLength" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonWidth')" prop="cartonWidth">
            <BjInputMoney v-model="goodsData.cartonWidth" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonHeight')" prop="cartonHeight">
            <BjInputMoney v-model="goodsData.cartonHeight" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonWeight')" prop="cartonWeight">
            <BjInputMoney v-model="goodsData.cartonWeight" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
              <template slot="append">kg</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Volume')">
            {{ (goodsData.cartonWidth*goodsData.cartonHeight*goodsData.cartonLength/1000000) }}m³
          </el-form-item>
          <!-- <el-form-item :label="$t('goodsSku.detail.Volume')">
            <BjInputMoney v-model="goodsData.volumeUnit" :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable>
            </BjInputMoney>
          </el-form-item> -->
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { roleApi, goodsApi, commonApi } from '@/api';
// import Upload from '@/components/Upload/index';
import BjUpload from '@/components/BjUpload/index';
import { parseTime } from '@/utils';

export default {
  components: {
    // Upload,
    BjUpload
  },
  mixins: [viewMiXin],
  props: {
    isAdd: {
      type: Boolean,
      default: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colSpan: 8,
      type: this.$route.query.type || null,
      goodsData: {
        id: this.$route.query.id || null,
        skuCode: '',
        skuDesc: '',
        itemType: '',
        categoryId: null,
        categoryName: '',
        barCode: '',
        vendorId: null,
        buyingDepId: null,
        buyerName: '',
        brandId: '',
        brandName: '',
        cartonBoxBarcode: '',
        seasonalGoods: 'AllSeas',
        merchandiser: '',
        merchandiser2: '',
        costPrice: null,
        salesPrice: null,
        activityPrice: null,
        marketPrice: null,
        distributionPrice: null,
        wholesalePrice: null,
        clearingPrice: null,
        rmb: null,
        asignBarcode: true,
        discontinued: true,
        inventoryItem: true,
        purchaseItem: true,
        salesItem: true,
        isPrediction: true,
        fragile: false,
        dangerousGoods: false,
        flammable: false,
        imageUrl: '',
        skuLicenseList: [],
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        qty: 0,
        cartonLength: 0,
        cartonWidth: 0,
        cartonHeight: 0,
        cartonWeight: 0,
        volumeUnit: 0,
      },
      rules: {
        skuCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuDesc: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        itemType: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        categoryId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        vendorId: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        buyingDepId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        buyerName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        brandId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        cartonBoxBarcode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        merchandiser: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        costPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        salesPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        imageUrl: [{ required: true, message: this.$t('goodsSku.detail.PleaseUpload'), trigger: 'blur' }],
        // activityPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // marketPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // distributionPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // wholesalePrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // clearingPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        length: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        width: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        height: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        weight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        qty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        cartonLength: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        cartonWidth: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        cartonHeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        cartonWeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      ROLE_LIST: [],
      ROLE_USER_LIST: [],
      BRAND_LIST: []
    };
  },
  created() {
    if (this.goodsData.id) {
      this.getGoodsDetailData();
    } else {
      this._getoneBarcode();
    }
    this._getRoleList();
    this._getPageBrand();
  },
  methods: {
    async _getPageBrand() {
      const res = await commonApi.getPageBrand({
        currentPage: 0,
        page: 0,
        pagesize: 999,
        size: 999,
        status: 1,
      });
      this.BRAND_LIST = res.content.map(item => {
        return {
          label: item.brandName,
          value: item.id,
        };
      });
    },
    async _getoneBarcode() {
      const res = await goodsApi.getoneBarcode();
      this.goodsData.barCode = res.message;
    },
    async getGoodsDetailData() {
      const res = await goodsApi.detailSku({ id: this.$route.query.id });
      this.goodsData = {
        ...res,
        asignBarcode: !!res.asignBarcode,
        discontinued: !!res.discontinued,
        inventoryItem: !!res.inventoryItem,
        purchaseItem: !!res.purchaseItem,
        salesItem: !!res.salesItem,
        isPrediction: !!res.isPrediction,
        fragile: !!res.fragile,
        dangerousGoods: !!res.dangerousGoods,
        flammable: !!res.flammable
      };
      console.log(this.goodsData);
    },
    async _getRoleList() {
      const res = await roleApi.getRoleList();
      this.ROLE_LIST = res.content.map(item => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    },
    changeCategory(item) {
      if (!item.label) return;
      this.goodsData.categoryName = item.label;
    },
    changeSupplier(v, item) {
      if (!item.label) return;
      this.goodsData.vendorName = item.label;
    },
    addSkuLicense() {
      this.goodsData.skuLicenseList.push({
        skuId: this.goodsData.id || null,
        licenseName: '',
        licenseExpireDate: '',
        licenseNode: ''
      });
    },
    changeRole(v, data) {
      this.goodsData.buyerName = '';
      this.goodsData.buyingDepName = data.label;
      roleApi.getUserListByRoleId({ roleId: v }).then(res => {
        this.ROLE_USER_LIST = res.content.map(item => {
          return {
            label: item.realName,
            value: item.id,
          };
        });
      });
    },
    changeBuyer(v, item) {
      if (!item.label) return;
      this.goodsData.buyerName = item.label;
    },
    changeBrand(v, item) {
      if (!item.label) return;
      this.goodsData.brandName = item.label;
    },
    beforeLicense() {
      return new Promise((resolve, reject) => {
        // this.$refs.uploadRef.uploadFileApi(this.goodsData.fileRaw).then(res => {
          // this.goodsData.imageUrl = res.message;
          // let bstop = false;
          const dateList = [];
          // if (this.goodsData.skuLicenseList.length == 0) return this.$message.error(this.$t('goodsSku.detail.leastCertificate'));
          this.goodsData.skuLicenseList.forEach(item => {
            dateList.push(item.licenseExpireDate);
            // if (!item.licenseName || !item.licenseExpireDate || !item.licenseNode) {
            //   bstop = true;
            // }
          });
          // if (bstop) return this.$message.error(this.$t('goodsSku.detail.PleaseContent'));
          const dateObjects = dateList.map(dateString => new Date(dateString));
          // 获取最小值
          const minDate = new Date(Math.min(...dateObjects));
          this.goodsData.licenseExpireDate = parseTime(minDate, '{y}-{m}-{d}') + ' 00:00:00';
          setTimeout(() => {
            resolve();
          }, 300);
        // });
      });
    },
    handleConfirm(flag) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.beforeLicense().then(() => {
              const obj = {
                ...this.goodsData,
                asignBarcode: this.goodsData.asignBarcode ? 1 : 0,
                discontinued: this.goodsData.discontinued ? 1 : 0,
                inventoryItem: this.goodsData.inventoryItem ? 1 : 0,
                purchaseItem: this.goodsData.purchaseItem ? 1 : 0,
                salesItem: this.goodsData.salesItem ? 1 : 0,
                isPrediction: this.goodsData.isPrediction ? 1 : 0,
                fragile: this.goodsData.fragile ? 1 : 0,
                dangerousGoods: this.goodsData.dangerousGoods ? 1 : 0,
                flammable: this.goodsData.flammable ? 1 : 0,
              };
              delete this.goodsData.fileRaw;
              if (this.goodsData.id) {
                goodsApi.updateSku({
                  flag,
                  sku: obj
                }).then(res => {
                  if (!res.failed) {
                    this.msgSuccess(this.$t('toast.operationSuccessText'));
                    this.goBack('/business/goods/sku/ordinary');
                  }
                });
              } else {
                goodsApi.addSku({
                  flag,
                  setFlag: 0, // 0-单品，1-套餐
                  skuList: [obj]
                }).then(res => {
                  if (!res.failed) {
                    this.msgSuccess(this.$t('toast.operationSuccessText'));
                    this.goBack('/business/goods/sku/ordinary');
                  }
                });
              }
          });
        }
      });
    },
    handleFileChange(file) {
      this.goodsData.fileRaw = file.raw;
      document.body.querySelector('.el-upload--picture-card').style.display = 'none';
    },
    handleRemove(file) {
      this.goodsData.fileRaw = null;
      document.body.querySelector('.el-upload--picture-card').style.display = '';
    },
    afterUpload(url) {
      this.goodsData.imageUrl = url;
    },
  },
};
</script>
